export default __webpack_public_path__ + "static/media/TimetableIcon.11a0986b.svg";